import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { Box, TextField } from '@mui/material';
import _ from 'lodash';
import { useRef } from 'react';
import { makeStyles } from 'tss-react/mui';
import LangEnum from '../../../../lang/LangEnum';
import useTeceoStyles from '../../../../useTeceoStyles';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import { useTranslation } from '../../../translation/TranslationContext';

const useStyles = makeStyles()((theme) => ({
  textField: {
    borderRadius: '8px',
    backgroundColor: theme.palette.grey[50],

    '& > fieldset': {
      borderColor: 'transparent',
    },
  },
}));

type ChatParticipantsSearchProps = {
  onChange: (value: string) => void;
};

const DEBOUNCE_FILELD_TIME = 800; // ms

const ChatParticipantsSearch = ({ onChange }: ChatParticipantsSearchProps) => {
  const { classes } = useStyles();
  const { classes: teceoClasses } = useTeceoStyles();
  const { translate } = useTranslation();
  const { isStore } = useApplicationContext();

  const debouncedSave = useRef(
    _.debounce((lazyValue) => {
      onChange(lazyValue);
    }, DEBOUNCE_FILELD_TIME),
  ).current;

  return (
    <TextField
      fullWidth
      size="small"
      variant="outlined"
      onChange={(event) => debouncedSave(event.target.value)}
      placeholder={translate(
        isStore ? LangEnum.GLOBAL_SEARCH_BRANDS : LangEnum.GLOBAL_SEARCH_STORES,
      )}
      slotProps={{
        input: {
          classes: { root: classes.textField },
          startAdornment: (
            <Box
              sx={{
                textAlign: 'center',
                mr: '8px',
              }}
            >
              <SearchRoundedIcon
                className={teceoClasses.svgIcon}
                color="disabled"
                fontSize="small"
              />
            </Box>
          ),
        },
      }}
    />
  );
};

export default ChatParticipantsSearch;
